/* global $ */

class PageContact {
  constructor(mainApp) {
    console.log('PageContact');
    this.mainApp = mainApp;

    if ($('.wpcf7').length) {
      var wpcf7El = document.querySelector('.wpcf7');

      // エラーが発生した時
      wpcf7El.addEventListener(
        'wpcf7invalid',
        () => {
          var speed = 400;
          setTimeout(function () {
            var firstErrorEl = $('.wpcf7-not-valid:first');
            var scrollAmount = firstErrorEl.offset().top;
            $('html, body').animate(
              { scrollTop: scrollAmount },
              speed,
              'swing'
            );
          }, 500);
        },
        false
      );

      wpcf7El.addEventListener(
        'wpcf7mailsent',
        () => {
          var speed = 400;
          setTimeout(function () {
            var firstErrorEl = $('.FormSubmit');
            var scrollAmount = firstErrorEl.offset().top;
            $('html, body').animate(
              { scrollTop: scrollAmount },
              speed,
              'swing'
            );
          }, 500);
        },
        false
      );
    }
  }
  onLoadWindow() {}
  onWindowResize() {}
  onWindowScroll() {}
  destroy() {}
}

export default PageContact;
